'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _PublishPropertyButton = require('./PublishPropertyButton.scss');var styles = _interopRequireWildcard(_PublishPropertyButton);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PublishPropertyButton = function PublishPropertyButton(props) {var _cx;return (
    _react2.default.createElement('button', {
        disabled: props.isDisabled,
        className: (0, _classnames2.default)(
        styles.publishButton,
        styles[props.theme],
        styles[props.size],
        styles[props.additionalStylingTheme], (_cx = {}, _cx[
        styles.disabled] = props.isDisabled, _cx)),

        onClick: props.onClick,
        id: props.id },

      _react2.default.createElement('span', { className: 'icon icon-plusIcon' }), '\xA0\xA0',
      _react2.default.createElement('span', { id: props.titleId }, props.title),
      props.caret && props.caret));}; // styles



PublishPropertyButton.propTypes = {
  onClick: _propTypes2.default.func,
  title: _propTypes2.default.string,
  theme: _propTypes2.default.oneOf(['primary', 'omBlue', 'foreign']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  additionalStylingTheme: _propTypes2.default.oneOf(['boldBorder']),
  id: _propTypes2.default.string,
  titleId: _propTypes2.default.string,
  caret: _propTypes2.default.any,
  isDisabled: _propTypes2.default.bool };exports.default =


PublishPropertyButton;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishPropertyButton/PublishPropertyButton.js
// module id = 2877
// module chunks = 0